import { useEffect, useState } from 'react';

import axios from 'axios';

import { API_ORIGIN } from '../config';

import type { PlaybackConfig } from '../utils/cctvStreamUrl';

const DEFAULT_CONFIG: PlaybackConfig = {
  use_remote_playback: false,
};

function samePlaybackConfig(a: PlaybackConfig, b: PlaybackConfig): boolean {
  if (a.use_remote_playback !== b.use_remote_playback) return false;
  if (a.public_api_base_url !== b.public_api_base_url) return false;
  if (a.hls_public_read !== b.hls_public_read) return false;
  if (a.hls_requires_token !== b.hls_requires_token) return false;
  if (Boolean(a.central_go2rtc_available) !== Boolean(b.central_go2rtc_available)) return false;
  const as = a.central_go2rtc_streams ?? [];
  const bs = b.central_go2rtc_streams ?? [];
  if (as.length !== bs.length) return false;
  for (let i = 0; i < as.length; i += 1) {
    if (as[i] !== bs[i]) return false;
  }
  return true;
}

export function usePlaybackConfig() {
  const [config, setConfig] = useState<PlaybackConfig>(DEFAULT_CONFIG);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await axios.get(`${API_ORIGIN}/api/gateway/playback-config`);
        if (cancelled || !res.data) return;
        const next: PlaybackConfig = {
          use_remote_playback: Boolean(res.data.use_remote_playback),
          public_api_base_url: res.data.public_api_base_url,
          hls_public_read: res.data.hls_public_read,
          hls_requires_token: res.data.hls_requires_token,
          central_go2rtc_available: Boolean(res.data.central_go2rtc_available),
          central_go2rtc_streams: Array.isArray(res.data.central_go2rtc_streams)
            ? res.data.central_go2rtc_streams.map(String)
            : [],
        };
        // 값 동일하면 setState 스킵 — 5초 폴링이 CCTV 카드 리마운트/깜빡임 유발 방지
        setConfig((prev) => (samePlaybackConfig(prev, next) ? prev : next));
      } catch {
        /* 로컬 개발: stream_url 폴백 */
      } finally {
        if (!cancelled) setLoaded(true);
      }
    };

    void load();
    const timer = window.setInterval(load, 15000);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  return {
    config,
    loaded,
    useRemotePlayback: config.use_remote_playback,
    centralGo2rtcAvailable: Boolean(config.central_go2rtc_available),
    centralGo2rtcStreams: config.central_go2rtc_streams ?? [],
  };
}
